import { Box, Text, SimpleGrid } from '@chakra-ui/react';
import { MatchCard } from './MatchCard';

interface LowerProbabilityMatchesProps {
  matches: any[];
  submittedFaceUrl: string | null;
  API_URL: string;
  onStatsOpen: () => void;
  setSelectedMatchStats: (match: any) => void;
  isSelectable?: boolean;
  selectedMatches?: Set<string>;
  onSelect?: (match: any, selected: boolean) => void;
}

export const LowerProbabilityMatches = ({ 
  matches, 
  submittedFaceUrl, 
  API_URL, 
  onStatsOpen, 
  setSelectedMatchStats,
  isSelectable = false,
  selectedMatches = new Set(),
  onSelect
}: LowerProbabilityMatchesProps) => {
  const lowerConfidenceMatches = matches.filter(match => match.similarity < 0.57);

  if (lowerConfidenceMatches.length === 0) {
    return null;
  }

  return (
    <Box w="full">
      <Text fontSize="2xl" fontWeight="bold" color="white" mb={4}>
        Lower Probability Matches
      </Text>
      <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={6}>
        {lowerConfidenceMatches.map((match, index) => (
          <MatchCard
            key={match.image_path}
            match={match}
            submittedFaceUrl={submittedFaceUrl}
            API_URL={API_URL}
            onStatsOpen={onStatsOpen}
            setSelectedMatchStats={setSelectedMatchStats}
            isSelectable={isSelectable}
            isSelected={selectedMatches.has(match.image_path)}
            onSelect={onSelect}
            isCompact={true}
          />
        ))}
      </SimpleGrid>
    </Box>
  );
}; 